import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { finalize } from 'rxjs/operators';
import { HttpActivityService } from '../services/http-activity.service';

/**
 * Stamps every request into {@link HttpActivityService} so the common busy latch can keep the control
 * that started a call disabled until that call finishes (see `runBusyClick`). Pure bookkeeping — it never
 * changes the request or the response.
 */
export const httpActivityInterceptor: HttpInterceptorFn = (req, next) => {
  const activity = inject(HttpActivityService);
  const seq = activity.start(req.method);
  return next(req).pipe(finalize(() => activity.finish(seq)));
};
